<template>
  <div id="adminFGMAutotrasportiDashboard">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Dashboard</li>
      <div style="position:absolute;right:15px;top:5px;display:flex;">
        <span style="padding:5px 10px;" class="form-control-range-data">Dal</span>
        <date-picker 
            :required="false"
            :disabled="false"
            id="dataForm" 
            name="dataForm" 
            class="form-control-range-data"
            :config="configDateTime"
            v-model="selectedFrom">
        </date-picker>
        <span style="padding:5px 10px;" class="form-control-range-data">Al</span>
        <date-picker 
            :required="false"
            :disabled="false"
            id="dataTo" 
            name="dataTo" 
            class="form-control-range-data"
            :config="configDateTime"
            v-model="selectedTo">
        </date-picker>
        <span style="padding:5px 5px;" class="form-control-range-data">&nbsp;</span>
        <button class="btn btn-light form-control-range-data" @click="applayDataChart()" style="margin-top:0px;">Applica</button>
        <span style="padding: 5px 10px 5px 5px;margin-top: -5px;border-left: 2px solid rgb(237, 237, 237);margin-left: 12px;margin-bottom: -3px;" class="form-control-range-data"></span>
        <select
          id="select-data"
          name="select-data"
          class="custom-select form-control service-areas form-control"
          v-on:change="onChangeData();"
          v-model="selected"
        >
          <option v-for="option in optionRangeData" v-bind:value="option.value">{{ option.text }}</option>
        </select>
      </div>
    </ol>
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-people bg-success p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-success">{{usersCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{users}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-chemistry bg-primary p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-primary">{{itemsCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{dashboardSession}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-notebook bg-danger p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-danger">{{itemsNotConfiguredCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{dashboardPagesViews}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-directions bg-warning p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-warning">{{pagePerSession}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{dashboardPagesPerSession}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[1]" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[2]" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[5]" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-people bg-success p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-success">{{sessioneMedia}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{dashboardAvgSession}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-chemistry bg-primary p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-primary">{{bounceRate}} %</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{dashboardBounceRate}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-notebook bg-danger p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-danger">{{realTimeUser}}</div>
                <div
                  class="text-muted text-uppercase font-weight-bold small"
                >{{dashboardRealTimeUser}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <graphic :configurations="configurationsLanguage[3]" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <graphic :configurations="configurationsLanguage[4]" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <div class="graphic-card div-most-visited">
              <div class="row">
                <div class="col-sm-12 col-md-10">
                  <h3>Url</h3>
                </div>
                <div class="col-sm-12 col-md-2 text-center">
                  <h3>{{dashboardViews}}</h3>
                </div>
              </div>
              <div class="row div-row-most-visited" v-for="row in mostVisitedPages" v-bind:key="row.field" >
                <div class="col-sm-12 col-md-10 align-self-center">{{row.url}}</div>
                <div class="col-sm-12 col-md-2 align-self-center text-center">
                  <b>{{row.pageview}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <div class="graphic-card div-most-visited">
              <div class="row">
                <div class="col-sm-12">
                  <h3>Attività recenti</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <h3>Data</h3>
                </div>
                <div class="col-sm-6">
                  <h3>Oggetto</h3>
                </div>
                <div class="col-sm-2">
                  <h3>Tipo</h3>
                </div>
                <div class="col-sm-1">
                  &nbsp;
                </div>
              </div>
              <div class="row div-row-most-visited" v-for="row in lastActivity" v-bind:key="row.field" >
                <div class="col-sm-3 align-self-center">
                  <b><i class="fa fa-clock-o"></i>&nbsp;{{row.data}}</b>
                </div>
                <div class="col-sm-6 align-self-center">
                  <b>{{row.oggetto}}</b>
                </div>
                <div class="col-sm-2 align-self-center">
                  <b>{{row.type}}</b>
                </div>
                <div class="col-sm-1 align-self-center" v-if="row.online==true">
                  <i class="fa fa-toggle-on" style="color:#1E9E74;"></i>
                </div> 
                <div class="col-sm-1 align-self-center" v-else>
                  <i class="fa fa-toggle-off" style="color:#D54C53;"></i>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Graphic from "@/components/Graphic.vue";

export default {
  name: "adminFGMAutotrasportiDashboard",
  components: {
    Graphic
  },
  data: function() {
    return {
      configDateTime: {
        format: storageData.sDateTimePickerFormat(),
        useCurrent: true,
        showClear: true,
        showClose: true
      },
      dashboardSession: dictionaryHelpers.getDictionary("DashboardSession"),
      dashboardPagesViews: dictionaryHelpers.getDictionary("DashboardPagesViews"),
      dashboardPagesPerSession: dictionaryHelpers.getDictionary("DashboardPagesPerSession"),
      dashboardAvgSession: dictionaryHelpers.getDictionary("DashboardAvgSession"),
      dashboardBounceRate: dictionaryHelpers.getDictionary("DashboardBounceRate"),
      dashboardRealTimeUser: dictionaryHelpers.getDictionary("DashboardRealTimeUser"),
      dashboardViews: dictionaryHelpers.getDictionary("DashboardViews"),
      dashboardSource: dictionaryHelpers.getDictionary("DashboardSource"),
      dashboardVisitors: dictionaryHelpers.getDictionary("DashboardVisitors"),
      dashboardTecnology: dictionaryHelpers.getDictionary("DashboardTecnology"),
      configurationsLanguage: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      items: dictionaryHelpers.getDictionary("Items"),
      itemsCount: 0,
      itemsNotConfigured: dictionaryHelpers.getDictionary("ItemsNotConfigured"),
      itemsNotConfiguredCount: 0,
      pagePerSession: 0,
      sessioneMedia: 0,
      bounceRate: 0,
      realTimeUser: 0,
      mostVisitedPages: [],
      lastActivity: [],
      selected: "30",
      optionRangeData: [
        { text: "Oggi", value: "0" },
        { text: "Ieri", value: "1" },
        { text: "7 gg", value: "7" },
        { text: "30 gg", value: "30" },
        { text: "90 gg", value: "90" },
        { text: "Ultimo anno", value: "365" },
        { text: "Personalizzato", value: "" }
      ],
      selectedFrom: "",
      selectedTo: "",
      lastSync: dictionaryHelpers.getDictionary("LastSync"),
      lastSyncDate: "",
      users: dictionaryHelpers.getDictionary("Users"),
      usersCount: 0
    };
  },
  created() {
    this.calculateRangeData(this.selected);
  },
  methods: {
    createGoogleAnalyticsGraphic(startDate, endDate) {
      var configurations = this;
       googleAnalyticsServices.getReturningVisitors(startDate, endDate, function(result) {
        var _background = [];
        $.each(result.data.datasets.backgroundColor.split(","), function(i,background) {
          _background[i] = background.trim();
        });
        result.data.datasets.backgroundColor = _background;
        configurations.configurationsLanguage[1] = {
          title: "Tipologia utenti",
          idCont: "chart_1",
          confGrafic: {
            type: "pie",
            data: {
              labels: result.data.labels,
              datasets: [result.data.datasets]
            },
            options: {
              legend: { position: "bottom" },
              animation: {
                animateRotate: false,
                animateScale: true
              },
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      display: false
                    },
                    ticks: {
                      display: false
                    }
                  }
                ],
                yAxes: [
                  {
                    gridLines: {
                      display: false
                    },
                    ticks: {
                      display: false
                    }
                  }
                ]
              }
            }
          }
        };
      });

      googleAnalyticsServices.getSourceSession(startDate, endDate, function(result) {
        var _background = [];
        $.each(result.data.datasets.backgroundColor.split(","), function(i,background) {
          _background[i] = background.trim();
        });

        result.data.datasets.backgroundColor = _background;
        configurations.configurationsLanguage[2] = {
          title: configurations.dashboardSource,
          idCont: "chart_2",
          confGrafic: {
            type: "pie",
            data: {
              labels: result.data.labels,
              datasets: [result.data.datasets]
            },
            options: {
              legend: {
                position: "bottom"
              },
              animation: {
                animateRotate: false,
                animateScale: true
              }
            }
          }
        };
      });

      googleAnalyticsServices.getVisitorsViews(startDate, endDate, function(
        result
      ) {
        configurations.configurationsLanguage[3] = {
          title: configurations.dashboardVisitors,
          idCont: "chart_3",
          confGrafic: {
            type: "line",
            data: {
              labels: result.data.labels,
              datasets: [result.data.datasets]
            },
            options: {
              legend: { display: false },
              title: {
                display: true
              },
              animation: {
                animateRotate: false,
                animateScale: true
              },
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      display: true
                    },
                    ticks: {
                      display: true
                    }
                  }
                ],
                yAxes: [
                  {
                    gridLines: {
                      display: true
                    },
                    ticks: {
                      display: true
                    }
                  }
                ]
              }
            }
          }
        };
      });

      googleAnalyticsServices.getPagesViews(startDate, endDate, function(
        result
      ) {
        configurations.configurationsLanguage[4] = {
          title: configurations.dashboardPagesViews,
          idCont: "chart_4",
          confGrafic: {
            type: "line",
            data: {
              labels: result.data.labels,
              datasets: [result.data.datasets]
            },
            options: {
              legend: { display: false },
              title: {
                display: true
              },
              animation: {
                animateRotate: false,
                animateScale: false
              },
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      display: true
                    },
                    ticks: {
                      display: true
                    }
                  }
                ],
                yAxes: [
                  {
                    gridLines: {
                      display: true
                    },
                    ticks: {
                      display: true
                    }
                  }
                ]
              }
            }
          }
        };
      });

      googleAnalyticsServices.getDeviceSession(startDate, endDate, function(
        result
      ) {
        var _background = [];
        $.each(result.data.datasets.backgroundColor.split(","), function(
          i,
          background
        ) {
          _background[i] = background.trim();
        });

        result.data.datasets.backgroundColor = _background;

        configurations.configurationsLanguage[5] = {
          title: configurations.dashboardTecnology,
          idCont: "chart_5",
          confGrafic: {
            type: "pie",
            data: {
              labels: result.data.labels,
              datasets: [result.data.datasets]
            },
            options: {
              legend: {
                position: "bottom"
              },
              animation: {
                animateRotate: false,
                animateScale: true
              }
            }
          }
        };
      });

      googleAnalyticsServices.getTotalUser(startDate, endDate, function(result) {
        configurations.usersCount = result.message;
      });

      googleAnalyticsServices.getTotalSession(startDate, endDate, function(result) {
        configurations.itemsCount = result.message;
      });

      googleAnalyticsServices.getTotalPageView(startDate, endDate, function(result) {
        configurations.itemsNotConfiguredCount = result.message;
      });

      googleAnalyticsServices.getPageViewPerSession(startDate, endDate,function(result) {
        configurations.pagePerSession = result.message;
      });

      googleAnalyticsServices.getAvgSessionDuration(startDate, endDate, function(result) {
        configurations.sessioneMedia = result.message.replace(":", " mm ") + " ss";
      });

      googleAnalyticsServices.getBounceRate(startDate, endDate, function(result) {
        configurations.bounceRate = result.message;
      });

      googleAnalyticsServices.getUserActiveRealTime(function(result) {
        configurations.realTimeUser = result.message;
      });

      googleAnalyticsServices.getMostVisitedPages(startDate, endDate, function(result) {
        configurations.mostVisitedPages = result.data;
      });

      pageServices.getLastActivity(function(result) {
        configurations.lastActivity = result.data;
      });

    },
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    },
    calculateRangeData(range) {
      var dateOdierna = new Date(),
        dataCalcolo = new Date();
      dateOdierna.setDate(dateOdierna.getDate() - range);
      dataCalcolo.setDate(dataCalcolo.getDate());
      var startDate =
        dateOdierna.getDate() +
        "-" +
        (dateOdierna.getMonth() + 1) +
        "-" +
        dateOdierna.getFullYear() +
        " 00:00:00";
      var endDate =
        dataCalcolo.getDate() +
        "-" +
        (dataCalcolo.getMonth() + 1) +
        "-" +
        dataCalcolo.getFullYear() +
        " 23:59:59";

      this.createGoogleAnalyticsGraphic(startDate, endDate);
    },
    onChangeData() {
      var dataSelected = this.selected;
      if(dataSelected==""){
        $('.form-control-range-data').fadeIn();
      }else{
        this.selectedFrom = "";
        this.selectedTo = "";
        $('.form-control-range-data').fadeOut();
        this.calculateRangeData(dataSelected);
      }
    },
    applayDataChart(){
      var startDate = this.selectedFrom.replace(/\//g, '-'),
          endDate = this.selectedTo.replace(/\//g, '-');

      this.createGoogleAnalyticsGraphic(startDate, endDate);
    }
  }
};
</script>
<style>
hr {
  border-color: rgba(0, 0, 0, 0);
}
.form-control-range-data{
  display:none;
}
.graphic-card {
  /* background: #ededed; */
  padding: 15px;
  border-radius: 5px;
  /*box-shadow:0px 0px 10px -5px rgba(0,0,0,0.3);*/
}
.graphic-title {
  position: absolute;
}
.graphic-title h6 {
  font-weight: bold;
}
.graphic-title h3 {
  font-size: 20px;
  font-weight: bold;
  color: #b5b5b5;
}
.div-most-visited h3 {
  font-size: 20px;
  font-weight: bold;
  color: #b5b5b5;
}
.div-row-most-visited {
  border-bottom: 1px solid #ededed;
  padding: 5px 0px;
}
.div-row-most-visited div {
  font-size: 14px;
}
.div-row-most-visited:last-child {
  border-bottom: 0px solid #ededed;
}
.container-fluid label {
  margin-bottom: 0px;
  font-weight: bold;
}
</style>
